import { render, staticRenderFns } from "./TemplateHeader.vue?vue&type=template&id=53ad980f&scoped=true"
import script from "./TemplateHeader.vue?vue&type=script&lang=js"
export * from "./TemplateHeader.vue?vue&type=script&lang=js"
import style0 from "./TemplateHeader.vue?vue&type=style&index=0&id=53ad980f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad980f",
  null
  
)

export default component.exports